import { selectFromCustomerNotificationOrganizationSettingsDto } from '../../models';

export default selectFromCustomerNotificationOrganizationSettingsDto()
  .etaWindowMinutesBefore
  .etaWindowMinutesAfter
  .driverOnTheWayThreshold
  .deliveryScheduledThreshold
  .deliveryMethod
  .etaTrackingLink
  .onTheWayTrackingLink
  .deliveredTrackingLink
  .missedTrackingLink
  .replyToEmail
  .allowSms
  .deliveryScheduled(b => b.enabled.emailTemplate(t => t.body.subject).smsTemplate(t => t.body))
  .onTheWay(b => b.enabled.emailTemplate(t => t.body.subject).smsTemplate(t => t.body))
  .successfulDelivery(b => b.enabled.emailTemplate(t => t.body.subject).smsTemplate(t => t.body))
  .missedDelivery(b => b.enabled.emailTemplate(t => t.body.subject).smsTemplate(t => t.body))
  .cancelledDelivery(b => b.enabled.emailTemplate(t => t.body.subject).smsTemplate(t => t.body))
  .businessName
  .phoneNumber
  .address
  .fromName
  .dateFormat
  .timeFormat
  .toString();
